module.exports = __webpack_public_path__ + "media/tema_2.1_infografia_interactiva_that_backpack_CF1.8f5bc30a.wav";